import React, { useState } from "react";
import { MdDoubleArrow } from "react-icons/md";
import { FaUserCheck, FaUserTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import {
  config,
  DOBASEURL,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../utils/helper";
import Spinner from "../Spinner/Spinner";
import { MdHistory } from "react-icons/md";
import Images from "../../utils/images";
import "./UserRequestCard.css";
import RejectModel from "../../Components/RejectModel/RejectModel";

const UserRequestCard = ({
  user,
  requestedUser,
  activeTab,
  reqId,
  sentAt,
  approvalAdminId,
  adminApprovedAt,
  comments,
  userApprovalAt,
  overAllAdminDecision,
  overAllAdminDecisionAt,
  overAllAdmincomments,
  overAllAdminId,
  setUserRequests,
  setAcceptedRequest,
  setRejectedRequest,
  setMutuallyAcceptedRequest,
  setAdminMutuallyReject,
  setPendingInTalkRequest,
  inTalkFromTab: initialInTalkFromTab,
  onActionSuccess,
}) => {
  const [loadingAcceptRequestId, setLoadingAcceptRequestId] = useState(null);
  const [loadingDenyRequestId, setLoadingDenyRequestId] = useState(null);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [inTalkWith, setInTalkWith] = useState(false);
  const [loadingInTalk, setLoadingInTalk] = useState(false);
  const [markingFixed, setMarkingFixed] = useState(false);
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");
  const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const canManage = role === "admin" || role === "superAdmin";

  const handleApproval = async (decision, isOverAllAdminApproval = false) => {
    if (decision === "approve") {
      setLoadingAcceptRequestId(reqId);
    } else {
      setLoadingDenyRequestId(reqId);
    }
    try {
      const data = {
        reqId: reqId,
        action: decision,
        comments: comment,
        adminId: adminId,
        isOverAllAdminApproval,
      };

      const res = await authorizedPost(
        configuration.apis.questionnaireApproval,
        data,
        config,
      );
      const response = res?.data?.data;
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        const users = [];
        const accpted = [];
        const rejected = [];
        const mutuallyAccepted = [];
        const mutuallyAdminReject = [];

        const pendingInTalk = [];
        response.forEach((value) => {
          if (value?.inTalk === true) {
            pendingInTalk.push(value);
          } else if (value?.adminApproval === "pending") {
            users.push(value);
          } else if (value?.overAllAdminDecision === "rejected") {
            mutuallyAdminReject.push(value);
          } else if (value?.adminApproval === "approved") {
            if (
              value?.userApproval === "approved" &&
              value?.overAllAdminDecision !== "rejected"
            ) {
              mutuallyAccepted.push(value);
            } else {
              accpted.push(value);
            }
          } else if (value?.adminApproval === "rejected") {
            rejected.push(value);
          } else if (value?.overAllAdminDecision === "rejected") {
            mutuallyAdminReject.push(value);
          }
        });

        setUserRequests(users);
        setAcceptedRequest(accpted);
        setRejectedRequest(rejected);
        setMutuallyAcceptedRequest(mutuallyAccepted);
        setAdminMutuallyReject(mutuallyAdminReject);
        setPendingInTalkRequest(pendingInTalk);
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      console.log(
        "Error in approval:",
        error.response ? error.response.data : error,
      );
      errorNotify("Error processing request.");
    } finally {
      setLoadingAcceptRequestId(null);
      setLoadingDenyRequestId(null);
    }
  };

  const handleInTalkWith = async (inTalk) => {
    setLoadingInTalk(true);
    try {
      const data = {
        requestId: reqId,
        adminId: adminId,
        inTalk,
        inTalkFromTab: inTalk ? activeTab : initialInTalkFromTab,
      };
      const res = await authorizedPost(
        configuration.apis.questionnaireInTalkStatus,
        data,
        config,
      );
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        const updated = res?.data?.requests || [];
        const pendingInTalk = [];
        const users = [];
        const accpted = [];
        const rejected = [];
        const mutuallyAccepted = [];
        const mutuallyAdminReject = [];
        updated.forEach((value) => {
          if (value?.inTalk === true) {
            pendingInTalk.push(value);
          } else if (value?.adminApproval === "pending") {
            users.push(value);
          } else if (value?.overAllAdminDecision === "rejected") {
            mutuallyAdminReject.push(value);
          } else if (value?.adminApproval === "approved") {
            if (
              value?.userApproval === "approved" &&
              value?.overAllAdminDecision !== "rejected"
            ) {
              mutuallyAccepted.push(value);
            } else {
              accpted.push(value);
            }
          } else if (value?.adminApproval === "rejected") {
            rejected.push(value);
          }
        });
        setUserRequests(users);
        setAcceptedRequest(accpted);
        setRejectedRequest(rejected);
        setMutuallyAcceptedRequest(mutuallyAccepted);
        setAdminMutuallyReject(mutuallyAdminReject);
        setPendingInTalkRequest(pendingInTalk);
      } else {
        errorNotify(res?.data?.message || "Failed to update status.");
      }
    } catch (error) {
      console.log("Error in inTalkWith:", error);
      errorNotify("Error updating status.");
    } finally {
      setLoadingInTalk(false);
    }
  };

  // Marks the mutually-accepted couple as "Marriage Fixed".
  // The next step (marking them "Married" with a date) happens separately,
  // on the "Users Status -> Marriage Fixed" tab (MarriedUsers.jsx) --
  // NOT here. This card only ever shows "Mark as Fixed".
  const handleMarkAsFixed = async () => {
    setMarkingFixed(true);
    try {
      const data = {
        adminId,
        reqId,
        maritalStatus: "marriage fixed",
      };
      const res = await authorizedPost(
        configuration.apis.questionnaireMaritalStatus,
        data,
        config,
      );
      const response = res?.data;
      if (response?.status) {
        successNotify(response?.message || "Marked as Marriage Fixed successfully!");
        onActionSuccess?.();
      } else {
        errorNotify(response?.message || "Failed to mark as fixed.");
      }
    } catch (error) {
      console.log(error);
      errorNotify("An error occurred while marking as fixed.");
    } finally {
      setMarkingFixed(false);
    }
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
  };

  const handleDeny = () => {
    setIsCommentSectionOpen(true);
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      if (activeTab === 3) {
        handleApproval("reject", true);
      } else {
        handleApproval("reject");
      }
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    }
  };

  const getDateBadgeColor = (date) => {
    const sentDate = new Date(date);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "bg-lime-500";
    if (diffInDays === 1) return "bg-fuchsia-500";
    if (diffInDays <= 3) return "bg-blue-500";
    if (diffInDays <= 7) return "bg-yellow-500";
    if (diffInDays <= 14) return "bg-pink-700";
    if (diffInDays <= 30) return "bg-cyan-500";
    if (diffInDays <= 60) return "bg-teal-500";
    if (diffInDays <= 90) return "bg-red-500";
    if (diffInDays <= 180) return "bg-purple-600";
    return "bg-gray-500";
  };

  const getTimeAgoLabel = (date) => {
    const sentDate = new Date(date);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    if (diffInDays <= 3) return "3 days ago";
    if (diffInDays <= 7) return "1 week ago";
    if (diffInDays <= 14) return "2 weeks ago";
    if (diffInDays <= 30) return "1 month ago";
    if (diffInDays <= 60) return "2 months ago";
    if (diffInDays <= 90) return "3 months ago";
    if (diffInDays <= 180) return "6 months ago";
    return "Over 6 months ago";
  };

  const formatDate = (date) =>
    date ? new Date(date).toLocaleDateString("en-GB") : "N/A";

  return (
    <div className="flex w-full flex-col items-center justify-between gap-2 rounded-lg bg-white p-2 shadow-md md:w-[40%] xl:w-[30%]">
      <div className="flex flex-col gap-2 xl:flex-row">
        <div className="flex w-full flex-row">
          
          <div className="flex flex-col items-center">
            <Link to={`viewProfile/${requestedUser?._id}`}>
              <div className="h-20 w-20 overflow-hidden rounded-full border-4">
                <img
                  src={
                    requestedUser?.images.length > 0
                      ? DOBASEURL + requestedUser?.images[0]
                      : requestedUser?.gender === "male"
                        ? Images.MEN
                        : Images.WOMEN
                  }
                  alt={requestedUser?.name}
                  className="h-full w-full cursor-pointer object-cover"
                  onContextMenu={(e) => e.preventDefault()}
                  onDragStart={(e) => e.preventDefault()}
                />
              </div>
            </Link>
            <div className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap pl-4">
              <h2 className="text-lg">{requestedUser?.name}</h2>
            </div>
          </div>

          <div className="mt-6 flex justify-center">
            <MdDoubleArrow style={{ fontSize: "40px", color: "#ffbb33" }} />
          </div>

       
          <div className="flex flex-col items-center">
            <Link to={`viewProfile/${user?._id}`}>
              <div className="h-20 w-20 overflow-hidden rounded-full border-4">
                <img
                  src={
                    user?.images.length > 0
                      ? DOBASEURL + user?.images[0]
                      : user?.gender === "male"
                        ? Images.MEN
                        : Images.WOMEN
                  }
                  alt={user?.name}
                  className="h-full w-full cursor-pointer object-cover"
                  onContextMenu={(e) => e.preventDefault()}
                  onDragStart={(e) => e.preventDefault()}
                />
              </div>
            </Link>
            <div className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap pl-4">
              <h2 className="text-lg">{user?.name}</h2>
            </div>
          </div>
        </div>
        
        {activeTab === 0 && canManage && (
          <div className="flex flex-row items-center justify-center gap-3 xl:flex-col">
            <button
              onClick={() => handleApproval("approve")}
              className="flex items-center justify-center rounded-full bg-green-500 px-2 py-2 text-white transition hover:bg-green-600"
              disabled={loadingAcceptRequestId === reqId}
            >
              {loadingAcceptRequestId === reqId ? <Spinner /> : <FaUserCheck />}
            </button>
            <button
              onClick={() => handleDeny("reject")}
              className="flex items-center justify-center rounded-full bg-red-500 px-2 py-2 text-white transition hover:bg-red-600"
              disabled={loadingDenyRequestId === reqId}
            >
              {loadingDenyRequestId === reqId ? <Spinner /> : <FaUserTimes />}
            </button>
          </div>
        )}
        {activeTab === 1 && canManage && (
          <div className="flex flex-row items-center justify-center gap-3 xl:flex-col">
            <button
              onClick={() => handleDeny("reject")}
              className="flex items-center justify-center rounded-full bg-red-500 px-2 py-2 text-white transition hover:bg-red-600"
              disabled={loadingDenyRequestId === reqId}
            >
              {loadingDenyRequestId === reqId ? <Spinner /> : <FaUserTimes />}
            </button>
          </div>
        )}
        {activeTab === 2 && canManage && (
          <div className="flex flex-row items-center justify-center gap-3 xl:flex-col">
            <button
              onClick={() => handleApproval("approve", false)}
              className="flex items-center justify-center rounded-full bg-blue-500 px-2 py-2 text-white transition hover:bg-blue-600"
              disabled={loadingDenyRequestId === reqId}
            >
              {loadingDenyRequestId === reqId ? <Spinner /> : <FaUserCheck />}
            </button>
          </div>
        )}
        {activeTab === 3 && canManage && (
          <div className="flex flex-row items-center justify-center gap-3 xl:flex-col">
            <button
              onClick={() => handleDeny("reject")}
              className="flex items-center justify-center rounded-full bg-red-500 px-2 py-2 text-white transition hover:bg-red-600"
              disabled={loadingDenyRequestId === reqId}
            >
              {loadingDenyRequestId === reqId ? <Spinner /> : <FaUserTimes />}
            </button>
          </div>
        )}
        {activeTab === 4 && canManage && (
          <div className="flex flex-row items-center justify-center gap-3 xl:flex-col">
            <button
              onClick={() => handleApproval("approve", true)}
              className="flex items-center justify-center rounded-full bg-blue-500 px-2 py-2 text-white transition hover:bg-blue-600"
              disabled={loadingDenyRequestId === reqId}
            >
              {loadingDenyRequestId === reqId ? <Spinner /> : <FaUserCheck />}
            </button>
          </div>
        )}
      </div>

     
      <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 text-xs text-gray-800 shadow-sm">
      
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center gap-1 font-semibold">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-blue-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H5a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2h-.003V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zM5 8h10v8H5V8z"
                clipRule="evenodd"
              />
            </svg>
            Proposal Date:
          </span>
          <span className="font-normal text-black">{formatDate(sentAt)}</span>
          {sentAt && (
            <span
              className={`ml-2 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium text-white shadow-sm ${getDateBadgeColor(sentAt)}`}
            >
              <MdHistory className="text-[12px]" />
              {getTimeAgoLabel(sentAt)}
            </span>
          )}
        </div>

       
        {activeTab === 1 && (
          <div className="flex flex-col gap-1 border-t border-gray-100 pt-2">
            <p className="font-semibold">
              Accepted By:{" "}
              <span className="font-normal text-green-600">
                {approvalAdminId?.name || "N/A"}
              </span>
            </p>
            <p className="font-semibold">
              Admin Accepted Date:{" "}
              <span className="font-normal text-black">
                {formatDate(adminApprovedAt)}
              </span>
            </p>
          </div>
        )}

       
        {activeTab === 2 && (
          <div className="flex flex-col gap-1 border-t border-gray-100 pt-2">
            <p className="font-semibold">
              Declined By:{" "}
              <span className="font-normal text-red-500">
                {approvalAdminId?.name || "N/A"}
              </span>
            </p>
            <p className="font-semibold">
              Admin Declined Date:{" "}
              <span className="font-normal text-black">
                {formatDate(adminApprovedAt)}
              </span>
            </p>
            <p className="font-semibold">
              User Not Accepted Date:{" "}
              <span className="font-normal text-black">
                {formatDate(userApprovalAt)}
              </span>
            </p>
            <p className="font-semibold">
              Declined Reason:{" "}
              <span className="font-normal text-red-400">
                {comments || "N/A"}
              </span>
            </p>
          </div>
        )}

      
        {activeTab === 3 && (
          <div className="flex flex-col gap-1 border-t border-gray-100 pt-2">
            <p className="font-semibold">
              Accepted By:{" "}
              <span className="font-normal text-green-600">
                {approvalAdminId?.name || "N/A"}
              </span>
            </p>
            <p className="font-semibold">
              Admin Accepted Date:{" "}
              <span className="font-normal text-black">
                {formatDate(adminApprovedAt)}
              </span>
            </p>
            <p className="font-semibold">
              User Approved Date:{" "}
              <span className="font-normal text-black">
                {formatDate(userApprovalAt)}
              </span>
            </p>
          </div>
        )}

        
        {activeTab === 4 && (
          <div className="flex flex-col gap-1 border-t border-gray-100 pt-2">
            <p className="font-semibold">
              Accepted By:{" "}
              <span className="font-normal text-green-600">
                {approvalAdminId?.name || "N/A"}
              </span>
            </p>
            <p className="font-semibold">
              Admin Accepted Date:{" "}
              <span className="font-normal text-black">
                {formatDate(adminApprovedAt)}
              </span>
            </p>
            <p className="font-semibold">
              Admin Declined Date:{" "}
              <span className="font-normal text-black">
                {formatDate(overAllAdminDecisionAt)}
              </span>
            </p>
            <p className="font-semibold">
              Declined By:{" "}
              <span className="font-normal text-red-500">
                {overAllAdminId?.name || "N/A"}
              </span>
            </p>
            <p className="font-semibold">
              Declined Reason:{" "}
              <span className="font-normal text-red-400">
                {overAllAdmincomments || "N/A"}
              </span>
            </p>
          </div>
        )}
      </div>

    
      {canManage &&
        (activeTab !== 5 ? (
          <button
            className="cursor-pointer text-xs text-blue-500 hover:underline disabled:opacity-50"
            onClick={() => handleInTalkWith(true)}
            disabled={loadingInTalk}
          >
            {loadingInTalk ? (
              <Spinner className="mx-auto" />
            ) : (
              "In Talk With User"
            )}
          </button>
        ) : (
          <button
            className="cursor-pointer text-xs text-red-500 hover:underline disabled:opacity-50"
            onClick={() => handleInTalkWith(false)}
            disabled={loadingInTalk}
          >
            {loadingInTalk ? <Spinner className="mx-auto" /> : "Revoke"}
          </button>
        ))}

      {activeTab === 3 && canManage && (
        <button
          type="button"
          onClick={handleMarkAsFixed}
          disabled={markingFixed}
          className="cursor-pointer rounded-lg bg-textYellow px-4 py-1 text-xs text-white transition hover:opacity-90 disabled:opacity-50"
        >
          {markingFixed ? <Spinner size="small" /> : "Mark as Fixed"}
        </button>
      )}

      <p className="text-xs text-gray-400">Click profile to see full details</p>
      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            isShowDropdown={true}
          />
        </div>
      )}
    </div>
  );
};

export default UserRequestCard;